import { render } from "./TipsWaters.vue?vue&type=template&id=25f464c6"
import script from "./TipsWaters.vue?vue&type=script&lang=js"
export * from "./TipsWaters.vue?vue&type=script&lang=js"
script.render = render

export default script